module.exports = __webpack_public_path__ + "media/images/favicon-1c7a598fa479dd74af4f2aebd819b5cb.ico";